import { Button, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap"
import { BsClipboardData, BsGraphUp, BsTag } from "react-icons/bs"
import ControlPanelActiveButtonEnum from "../../domain/enum/ControlPanelActiveButtonEnum"
import { ManageCourseSideMenuStyles } from './styles'
import { useHistory } from "react-router"
import { getDecodedToken } from "../../router/TokenUtils"

interface ControlPanelSideMenuProps {
    activeButton: ControlPanelActiveButtonEnum
    setActivePage: (activePage: ControlPanelActiveButtonEnum) => void
    setIsLoading: (loading: boolean) => void
}


const ControlPanelSideMenu = (props: ControlPanelSideMenuProps) => {
    const history = useHistory();

    function activeReports() {
        history.push("/controlpanel/reports")
        props.setActivePage(ControlPanelActiveButtonEnum.reports)
        props.setIsLoading(true)
    }
    function activeCampaigns() {
        history.push("/controlpanel/campaigns")
        props.setActivePage(ControlPanelActiveButtonEnum.campaigns)
        props.setIsLoading(true)
    }

    function activeReportDetails() {
        history.push("/controlpanel/reportdetails")
        props.setActivePage(ControlPanelActiveButtonEnum.reportDetails)
        props.setIsLoading(true)
    }

    const decodedToken = getDecodedToken();
    const isFMC = decodedToken ? decodedToken.institutionId.toLocaleUpperCase() === "8A8135C3-9D98-47FC-9537-ACB4765B236B" : false;

    return (
        <ManageCourseSideMenuStyles md={"auto"}>
            <Row className="mt-4 nav-buttons">
                <Col>
                    <ListGroup className="px-2">
                        <ListGroupItem className="px-0 py-0">
                            <Button className={props.activeButton === ControlPanelActiveButtonEnum.reports ? "active" : ""} onClick={activeReports}>
                                <Row>
                                    <Col md="auto" className="pr-0 py-2">
                                        <BsClipboardData size="2.78vmin" />
                                    </Col>
                                    <Col md="auto" className="my-auto">
                                        Dados Gerais
                                    </Col>
                                </Row>
                            </Button>
                        </ListGroupItem>
                    </ListGroup>
                    {isFMC && (
                        <ListGroup className="px-2">
                            <ListGroupItem className="px-0 py-0">
                                <Button className={props.activeButton === ControlPanelActiveButtonEnum.reportDetails ? "active" : ""} onClick={activeReportDetails}>
                                    <Row>
                                        <Col md="auto" className="pr-0 py-2">
                                            <BsGraphUp size="2.78vmin" />
                                        </Col>
                                        <Col md="auto" className="my-auto">
                                            Relatórios
                                        </Col>
                                    </Row>
                                </Button>
                            </ListGroupItem>
                        </ListGroup>
                    )}
                    <ListGroup className="px-2">
                        <ListGroupItem className="px-0 py-0">
                            <Button className={props.activeButton === ControlPanelActiveButtonEnum.campaigns ? "active" : ""} onClick={activeCampaigns}>
                                <Row>
                                    <Col md="auto" className="pr-0 py-2">
                                    <BsTag size="2.78vmin" />
                                    </Col>
                                    <Col md="auto" className="my-auto">
                                        Campanhas
                                    </Col>
                                </Row>
                            </Button>
                        </ListGroupItem>
                    </ListGroup>
                </Col>
            </Row>
            <Row className="fixed-bottom">
                <Col md="auto" className="mx-auto mb-4">
                    <img className="" src="/img/report/woman_looking_report.svg" alt="" />
                </Col>
            </Row>
        </ManageCourseSideMenuStyles>
    )
}

export default ControlPanelSideMenu;
